import usePriceQuote from 'hooks/queries/quotes';
import useStyleById from 'hooks/queries/styleById';

const getQuoteQuantities = (styleObj) => {
  return styleObj?.specialty ? [100, 250, 500, 1000] : [25, 50, 100, 250];
};

const useGetQuickViewData = (styleId) => {
  const {
    data: style,
    error: styleError,
    isLoading: isStyleLoading
  } = useStyleById(styleId);
  const {
    data: quoteData,
    error: quoteError,
    isLoading: isQuoteLoading
  } = usePriceQuote(styleId, getQuoteQuantities(style), 1, 0, !!style);

  return {
    isError: styleError || quoteError,
    isLoading: isStyleLoading || isQuoteLoading,
    quoteData,
    style
  };
};

export default useGetQuickViewData;
